<div class="container">
  <h1 class="page-title">
    <span class="icon"><i class="fas fa-truck"></i></span>Booking 表頭編輯
  </h1>
  <p-card>
    <form class="detail-form">
      <div class="field grid">
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Facility" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.facility | optionsMapping: facilityOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.BookingNum" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.bookingNo | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.BookingStatus" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.bookingStatus | optionsMapping: bookingStatusOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.CarTripNum" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.carTrip | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Forwarder" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.bookingForwarder | optionsMapping: forwarderOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.AssignTime" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.tmpAssignDate | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DepartureTime" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.tmpCarSeq | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.VehicleType" | translate }}</label>
          <div class="col-8 column-value" *ngIf="isEditCarType; then editCarType; else nonEditCarType"></div>
          <ng-template #editCarType>
            <laas-car-type-selector
              name="carType"
              [(ngModel)]="bookingModel.carType"
              [disabled]="isDisableWidget(bookingModel, 'carType') || isDisabledUpdate()"
            >
            </laas-car-type-selector>
          </ng-template>
          <ng-template #nonEditCarType>
            {{ bookingModel?.carType | replaceNullWith: "-" }}
          </ng-template>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.PayeeType" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="carrierPaymentType"
              *ngIf="!isFeeCalculation(); else nonEditCarrierPaymentType"
              [options]="carrierPaymentTypeOptions"
              (onChange)="changeCarrierPaymentBy()"
              [(ngModel)]="bookingModel.carrierPaymentType"
              [showClear]="true"
              [disabled]="isDisabledUpdate()"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            ></p-dropdown>
            <ng-template #nonEditCarrierPaymentType>
              {{ bookingModel?.carrierPaymentType | optionsMapping: carrierPaymentTypeOptions | replaceNullWith: "-" }}
            </ng-template>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Payee" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="carrierPaymentBy"
              *ngIf="!isFeeCalculation(); else nonEditCarrierPaymentBy"
              [options]="carrierPaymentByOptions"
              [(ngModel)]="bookingModel.carrierPaymentBy"
              [showClear]="true"
              [filter]="true"
              [disabled]="isDisabledUpdate()"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            ></p-dropdown>
            <ng-template #nonEditCarrierPaymentBy>
              {{ bookingModel?.carrierPaymentBy | optionsMapping: carrierPaymentByOptions | replaceNullWith: "-" }}
            </ng-template>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Company" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.letterOrgId | optionsMapping: letterHeadOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.BillComp" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.billCorp | optionsMapping: billCorpOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DeliveryType" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.deliveryType | optionsMapping: deliveryTypeOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DeliverySubType" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="deliverSubType"
              [options]="deliverSubTypeOptions"
              [(ngModel)]="bookingModel.deliverSubType"
              [showClear]="true"
              [disabled]="isDisabledUpdate()"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Type" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="bookingType"
              [options]="bookingTypeOptions"
              [(ngModel)]="bookingModel.bookingType"
              [disabled]="isDisabledUpdate()"
              [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.CustomerCodeName" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.consigneeKey | replaceNullWith: "-" }} -
            {{ bookingModel?.consigneeCompany | replaceNullWith: "" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.PickUpLocate" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="awbAddress"
              [(ngModel)]="bookingModel.awbAddress"
              [options]="pickupLocationOptions"
              [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            >
            </p-dropdown>
            <!-- {{ bookingModel?.awbAddress | optionsMapping: pickupLocationOptions | replaceNullWith: "-" }} -->
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label"><span class="requiredStart">*</span>{{ "BookingHeaderDetails.Form.TradeTerm" | translate }}</label>
          <div *ngIf="isEditShipTerm" class="col-8 column-value">
            <p-dropdown name="shipTerm" [filter]="true" [showClear]="true" [options]="incoTermOptions"
                [(ngModel)]="bookingModel.shipTerm" (onChange)="changeCharge()"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                (keydown)="onDropdownKeydown($event)"></p-dropdown>
          </div>
          <div *ngIf="!isEditShipTerm" class="col-8 column-value">
            {{ bookingModel?.shipTerm | optionsMapping: incoTermOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.OriginCountry" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.fromCountry | optionsMapping: countryOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.OriginCity" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.fromCity | optionsMapping: fromCityOptions | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.OriginArea" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="fromArea"
              [(ngModel)]="bookingModel.fromArea"
              [options]="rfqAreaOptions"
              [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DestiCountry" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="toCountry"
              [(ngModel)]="bookingModel.toCountry"
              [options]="countryOptions"
              [showClear]="true"
              (onChange)="changeCityOptions()"
              [filter]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DestiCity" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="toCity"
              [(ngModel)]="bookingModel.toCity"
              [options]="cityOptions"
              [showClear]="true"
              (onChange)="changeAreaOptions()"
              [filter]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DestiArea" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="toArea"
              [(ngModel)]="bookingModel.toArea"
              [options]="toAreaOptions"
              [showClear]="true"
              [filter]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DestiAirport" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="toArea"
              [(ngModel)]="bookingModel.toAirport"
              [options]="toAirportOptions"
              [showClear]="true"
              [filter]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TotalCartonCnt" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel.totalCaseCnt | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.RevisedCartonCnt" | translate }}</label>
          <div class="col-8 column-value" *ngIf="isEditTotalCaseCnt; then editTotalCaseCnt; else nonEditTotalCaseCnt"></div>
          <ng-template #editTotalCaseCnt>
            <p-inputNumber
              name="updatedTotalCaseCnt"
              [(ngModel)]="bookingModel.updatedTotalCaseCnt"
              styleClass="text-right"
            ></p-inputNumber>
          </ng-template>
          <ng-template #nonEditTotalCaseCnt>
            {{ bookingModel?.updatedTotalCaseCnt | number | replaceNullWith: "-" }}
          </ng-template>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TotalGrossWeight" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.totalGrosswgt | number: ".2-2" | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.RevisedGrossWeight" | translate }}</label>
          <div class="col-8 column-value" *ngIf="isEditTotalGrosswgt; then editTotalGrosswgt; else nonEditTotalGrosswgt"></div>
          <ng-template #editTotalGrosswgt>
            <p-inputNumber
              name="updatedTotalGrosswgt"
              [(ngModel)]="bookingModel.updatedTotalGrosswgt"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              styleClass="text-right"
            ></p-inputNumber>
          </ng-template>
          <ng-template #nonEditTotalGrosswgt>
            {{ bookingModel?.updatedTotalGrosswgt | number: ".2-2" | replaceNullWith: "-" }}
          </ng-template>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TotalDim" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.totalVolumeWeight | number: ".2-2" | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.RevisedDim" | translate }}</label>
          <div class="col-8 column-value" *ngIf="isEditTotalVolumeWeight; then editTotalVolumeWeight; else nonEditTotalVolumeWeight"></div>
          <ng-template #editTotalVolumeWeight>
            <p-inputNumber
              name="updatedTotalVolumeWeight"
              [(ngModel)]="bookingModel.updatedTotalVolumeWeight"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              styleClass="text-right"
            ></p-inputNumber>
          </ng-template>
          <ng-template #nonEditTotalVolumeWeight>
            {{ bookingModel?.updatedTotalVolumeWeight | number: ".2-2" | replaceNullWith: "-" }}
          </ng-template>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TotalNetWeight" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.totalNetWeight | number: ".2-2" | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TotalPalletCnt" | translate }}</label>
          <div class="col-8 column-value" *ngIf="isEditTotalPalletCnt; then editTotalPalletCnt; else nonEditTotalPalletCnt"></div>
          <ng-template #editTotalPalletCnt>
            <p-inputNumber
              name="totalPalletCnt"
              [(ngModel)]="bookingModel.totalPalletCnt"
              styleClass="text-right"
            ></p-inputNumber>
          </ng-template>
          <ng-template #nonEditTotalPalletCnt>
            {{ bookingModel?.totalPalletCnt | number | replaceNullWith: "-" }}
          </ng-template>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TotalPalletWeight" | translate }}</label>
          <div class="col-8 column-value" *ngIf="isEditTotalPalletWeight; then editTotalPalletWeight; else nonEditTotalPalletWeight"></div>
          <ng-template #editTotalPalletWeight>
            <p-inputNumber
              name="totalPalletWeight"
              [(ngModel)]="bookingModel.totalPalletWeight"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              styleClass="text-right"
            ></p-inputNumber>
          </ng-template>
          <ng-template #nonEditTotalPalletWeight>
            {{ bookingModel?.totalPalletWeight | number: ".2-2" | replaceNullWith: "-" }}
          </ng-template>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.FreightCharge" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="airfreightCharge"
              [disabled]="isDisabledUpdate()"
              [options]="chargeOptions"
              [(ngModel)]="bookingModel.airfreightCharge"
              [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.TotalQty" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.totalQty | number: ".2-2" | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.OtherCharge" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="otherCharge"
              [disabled]="isDisabledUpdate()"
              [options]="chargeOptions"
              [(ngModel)]="bookingModel.otherCharge"
              [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.EstimateCharges" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.estimatedCost | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.RFQ" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.quotationKey | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-center">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.DeliveryRemarks" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              [disabled]="isDisabledUpdate()"
              [(ngModel)]="bookingModel.remarks"
              name="remarks"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-center">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.NotifyRemark" | translate }}</label>
          <div class="col-8 column-value">
            <textarea
              pInputTextarea
              name="notifyRemarks"
              [rows]="3"
              [(ngModel)]="bookingModel.notifyRemarks"
              [disabled]="isDisabledUpdate()"
            ></textarea>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.PaymentType" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="payType"
              [disabled]="isDisabledUpdate()"
              [options]="payTypeOptions"
              [(ngModel)]="bookingModel.payType"
              [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            ></p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.PermitNo" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              [(ngModel)]="bookingModel.permitNo"
              name="permitNo"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.AccountID" | translate }}</label>
          <div class="col-8 column-value">
            <ng-container *ngIf="bookingModel.payType === 'S'; else accountIdInput">
              <p-dropdown
                name="accountId"
                [options]="accountIdOptions"
                [(ngModel)]="bookingModel.accountId"
                [showClear]="true"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [disabled]="isDisabledUpdate()"
                styleClass="p-text-left"
                (keydown)="onDropdownKeydown($event)"
              >
              </p-dropdown>
            </ng-container>
            <ng-template #accountIdInput>
              <input
                pInputText
                name="accountId"
                [disabled]="isDisabledUpdate()"
                [(ngModel)]="bookingModel.accountId"
              />
            </ng-template>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.MAWB" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              [(ngModel)]="bookingModel.mawb"
              name="mawb"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.HAWB" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              [(ngModel)]="bookingModel.expressBill"
              name="expressBill"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.ExpandField" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              [disabled]="isDisabledUpdate()"
              [(ngModel)]="bookingModel.extensionField"
              name="extensionField"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.ConsigneeCO" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="coOrgId"
              [options]="letterHeadOptions"
              [(ngModel)]="bookingModel.coOrgId"
              [disabled]="isDisabledUpdate()"
              [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.ReceiptFormNum" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.whNo | replaceNullWith: "-" }}
          </div>
        </div>

        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.ExpressTerm" | translate }}</label>
          <div class="col-8 column-value" *ngIf="isEditBookingFormExpressTerm; then editBookingFormExpressTerm; else nonEditBookingFormExpressTerm"></div>
          <ng-template #editBookingFormExpressTerm>
            <div class="col-8 column-value">
              <p-dropdown
                name="expressTerm"
                [options]="expressTermOptions"
                [(ngModel)]="bookingModel.expressTerm"
                [showClear]="true"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                styleClass="p-text-left"
                (keydown)="onDropdownKeydown($event)"
              >
              </p-dropdown>
            </div>
          </ng-template>
          <ng-template #nonEditBookingFormExpressTerm>
            {{ bookingModel?.expressTerm | replaceNullWith: "-" }}
          </ng-template>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.ShipCorp" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              [(ngModel)]="bookingModel.shipCorp"
              name="shipCorp"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Flight1Vehicle1" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              [(ngModel)]="bookingModel.flightNo1"
              name="flightNo1"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.FlightDate1" | translate }}</label>
          <div class="col-8 column-value">
            <p-calendar
              [(ngModel)]="bookingModel.flyDate1TimeZone"
              name="flyDate1"
              dateFormat="yy/mm/dd"
              dataType="string"
              appendTo="body"
            >
            </p-calendar>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.Flight2Vehicle2" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              [(ngModel)]="bookingModel.flightNo2"
              name="flightNo2"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.FlightDate2" | translate }}</label>
          <div class="col-8 column-value">
            <p-calendar
              [(ngModel)]="bookingModel.flyDate2TimeZone"
              name="flyDate2"
              dateFormat="yy/mm/dd"
              dataType="string"
              appendTo="body"
            >
            </p-calendar>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.ShippingMethod" | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown
              name="shippingMethod"
              [options]="shipMethodOptions"
              [(ngModel)]="bookingModel.shippingMethod"
              [disabled]="isDisabledUpdate()"
              [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left"
              (keydown)="onDropdownKeydown($event)"
            ></p-dropdown>
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.InHouseNo" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              [(ngModel)]="bookingModel.inHouseNo"
              name="inHouseNo"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "BookingHeaderDetails.Form.UDR" | translate }}</label>
          <div class="col-8 column-value">
            <input
              pInputText
              type="text"
              [(ngModel)]="bookingModel.udr"
              name="udr"
            />
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "Common.Label.CreateUser" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.createUser | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "Common.Label.CreateDate" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.createDt | date: "YYYY-MM-dd HH:mm:ss": this.laasSetting.facilityTimeZone | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "Common.Label.UpdateUser" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.updateUser | replaceNullWith: "-" }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-4 column-label">{{ "Common.Label.UpdateDate" | translate }}</label>
          <div class="col-8 column-value">
            {{ bookingModel?.updateDt | date: "YYYY-MM-dd HH:mm:ss": this.laasSetting.facilityTimeZone | replaceNullWith: "-" }}
          </div>
        </div>
      </div>

      <div class="grid">
        <div class="col">
          <button
            pButton
            pRipple
            label="{{ 'Common.Button.Save' | translate }}"
            (click)="saveBtnClick($event)"
            class="mr-2"
          ></button>
          <button
            pButton
            pRipple
            label="{{ 'Common.Button.ReturnWithoutSaving' | translate }}"
            class="mr-2"
            (click)="goToLastPage()"
          ></button>
        </div>
      </div>
    </form>
  </p-card>
</div>
